var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTenda(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.303,
    height: 21.56,
    viewBox: "0 0 24.303 21.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.583 7.415)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.53315925598145 13.14408206939697 L 1.737479686737061 13.14408206939697 C 1.055129766464233 13.14408206939697 0.4999997019767761 12.66214179992676 0.4999997019767761 12.06976222991943 L 0.4999997019767761 1.574321985244751 C 0.4999997019767761 0.9819419980049133 1.055129766464233 0.5000019669532776 1.737479686737061 0.5000019669532776 L 18.53315925598145 0.5000019669532776 C 19.21550941467285 0.5000019669532776 19.77063941955566 0.9819419980049133 19.77063941955566 1.574321985244751 L 19.77063941955566 12.06976222991943 C 19.77063941955566 12.66214179992676 19.21550941467285 13.14408206939697 18.53315925598145 13.14408206939697 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.737480163574219 1.000001907348633 C 1.337718963623047 1.000001907348633 1 1.263002395629883 1 1.574312210083008 L 1 12.06976222991943 C 1 12.38107204437256 1.337718963623047 12.64408206939697 1.737480163574219 12.64408206939697 L 18.53315925598145 12.64408206939697 C 18.93292045593262 12.64408206939697 19.27063941955566 12.38107204437256 19.27063941955566 12.06976222991943 L 19.27063941955566 1.574312210083008 C 19.27063941955566 1.263002395629883 18.93292045593262 1.000001907348633 18.53315925598145 1.000001907348633 L 1.737480163574219 1.000001907348633 M 1.737480163574219 1.9073486328125e-06 L 18.53315925598145 1.9073486328125e-06 C 19.49274063110352 1.9073486328125e-06 20.27063941955566 0.7048416137695312 20.27063941955566 1.574312210083008 L 20.27063941955566 12.06976222991943 C 20.27063941955566 12.93924236297607 19.49274063110352 13.64408206939697 18.53315925598145 13.64408206939697 L 1.737480163574219 13.64408206939697 C 0.7778987884521484 13.64408206939697 0 12.93924236297607 0 12.06976222991943 L 0 1.574312210083008 C 0 0.7048416137695312 0.7778987884521484 1.9073486328125e-06 1.737480163574219 1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#000FFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.106 10.577)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.843,
    height: 8.347,
    rx: 1,
    fill: "#000FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.173,
    height: 4.173,
    rx: 1,
    transform: "translate(9.181)",
    fill: "#000FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.047-.764H20.42l3.765,6.909H.883Z",
    transform: "translate(-0.883 0.764)",
    fill: "#fff",
    stroke: "#000FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.871,0c2.549-.014,2.84,2.966,2.84,2.966H0S.321.014,2.871,0Z",
    transform: "translate(5.77 9.95) rotate(180)",
    fill: "#fff",
    stroke: "#000FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.871,0c2.549-.014,2.84,2.966,2.84,2.966H0S.321.014,2.871,0Z",
    transform: "translate(11.614 9.95) rotate(180)",
    fill: "#fff",
    stroke: "#000FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.871,0c2.549-.014,2.84,2.966,2.84,2.966H0S.321.014,2.871,0Z",
    transform: "translate(17.459 9.95) rotate(180)",
    fill: "#fff",
    stroke: "#000FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.871,0c2.549-.014,2.84,2.966,2.84,2.966H0S.321.014,2.871,0Z",
    transform: "translate(23.303 9.95) rotate(180)",
    fill: "#fff",
    stroke: "#000FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y1: 7.095,
    x2: 1.52,
    transform: "translate(5.888 0.067)",
    fill: "none",
    stroke: "#000FFF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y1: 6.589,
    transform: "translate(11.463 0.067)",
    fill: "none",
    stroke: "#000FFF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.027,
    y1: 7.095,
    transform: "translate(15.517 0.067)",
    fill: "none",
    stroke: "#000FFF",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenda);
export default __webpack_public_path__ + "static/media/tenda.35d39026bb0c291f4cfa52b4957bf96a.svg";
export { ForwardRef as ReactComponent };